import React from "react"
import { getCardImage } from "../../helpers/getCardTypeImage"
import { AiOutlineEdit } from "react-icons/ai";

const ExistingCard = ({card, i, cardId, onCardClick, onCardChange, groupName = "card-item", editable, onEditClick}) => {
    return(
        <div className="card-list-el position-relative" key={`card-item-${i}`} style={{marginBottom: "6px"}}>
            <input 
                id={`x${groupName}-${card.id}`} 
                value={card.id} 
                type="radio" 
                name={groupName}
                checked={card.id == cardId}   
                onChange={(e) => onCardChange(e.target.value)}                           
            />
            <label htmlFor={`x${groupName}-${card.id}`} onClick={() => onCardClick(i)} style={{paddingRight: editable ? "32px" : "9px"}}>
                <span></span>
                <p>{`x${card.last_four}`} <span>{card.expiration_month}/{card.expiration_year}</span></p>
                <img src={getCardImage(card.card_type)} alt="visa"/>
            </label>
            {editable && 
                <AiOutlineEdit 
                    onClick={() => onEditClick(card.id)}
                    style={{position: "absolute", right: 0, top: "9px", right: "10px", opacity: "0.6", cursor: "pointer"}}
                />
            }
        </div>
    )
}
export default ExistingCard